import { FormGroup } from "@blueprintjs/core";
import { ColorInput } from "@package/ui-components";
import type { ExtraFieldTypeColor } from "@package/ui-gql/index-data-access";
import { get, set } from "lodash";
import { useMemo } from "react";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldColorProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeColor;
};

function ServiceDataFormFieldColorContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldColorProps) {
  const value = useMemo<string>(
    () => get(data, field.source) ?? field.defaultValue ?? "",
    [data, field.defaultValue, field.source],
  );

  return (
    <FormGroup label={field.label}>
      <ColorInput
        value={value}
        onValueChange={(v) =>
          onSourceChanged((draft) => {
            set(draft, field.source, v);
          })
        }
      />
    </FormGroup>
  );
}

export function ServiceDataFormFieldColor({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeColor") {
    return (
      <ServiceDataFormFieldColorContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
